import { render } from "./OrganizerView.vue?vue&type=template&id=38503f22&scoped=true"
import script from "./OrganizerView.vue?vue&type=script&lang=js"
export * from "./OrganizerView.vue?vue&type=script&lang=js"

import "./OrganizerView.vue?vue&type=style&index=0&id=38503f22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38503f22"]])

export default __exports__